import React, { Component } from "react";
import { Row } from "react-bootstrap";
import Card from "./Card";

class Cards extends Component {
  render() {
    return (
      <Row>
        <Card header="Dobry na start">
          C++ pozwala na wiele możliwości, podczas nauki{" "}
          <b>nauczysz się wiele podstaw i pojęć,</b>
          które są używane w programowaniu np. referencja, typy danych .itd
        </Card>
        <Card header="Twórz różne aplikacje">
          Twórz aplikacje z interefejsem graficznym, gry oraz aplikacje mobilne
        </Card>
        <Card header="Ogarnij programowanie">
          Naucz się pewnych koncepcji używanych w programowaniu
        </Card>
      </Row>
    );
  }
}

export default Cards;
